import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { PRINT_CONTAINER_ID } from "./Certificate";

export function printCertificate() {
  const input = document.getElementById(PRINT_CONTAINER_ID);
  if (!input) {
    console.error("HTML element to print not found!");
    return;
  }

  const vw = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
  let imgWidth = 1920;

  // Fixes cetificate issue in ipad
  if (vw < 1920) {
    imgWidth = vw;
  }

  html2canvas(input).then((canvas) => {
    let imgHeight = Math.floor((canvas.height * imgWidth) / canvas.width);

    const imgData = canvas.toDataURL("img/png");
    const pdf = new jsPDF("l", "px", [imgWidth, imgHeight], false);
    pdf.addImage(imgData, "PNG", -15, 0, imgWidth + 15, imgHeight);
    pdf.save("byblack-certification.pdf");
  });
}

export function downloadBadge() {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  const base_image = new Image();
  base_image.src = "/assets/images/badge-new.png";
  base_image.onload = function () {
    if (!context) {
      console.error("Canvas context to download badge not found!");
      return;
    }

    canvas.width = base_image.width;
    canvas.height = base_image.height;

    context.drawImage(base_image, 0, 0);

    const badge = canvas.toDataURL("image/png");
    const download = document.createElement("a");
    download.href = badge;
    download.download = "byblack-badge.png";
    download.click();
    canvas.remove();
  };
}
